import React from 'react'
import { cn } from '@/lib/utils'

type PillTone = "primary" | "secondary" | "accent" | "muted"

interface PillProps {
  children: React.ReactNode
  tone?: PillTone
  className?: string
}

const toneClasses: Record<PillTone, string> = {
  primary:   "bg-primary text-primary-foreground",
  secondary: "bg-secondary text-secondary-foreground",
  accent:    "bg-accent text-accent-foreground",
  muted:     "bg-muted text-muted-foreground",
}

export function Pill({ children, tone = "muted", className }: PillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold",
        toneClasses[tone],
        className
      )}
    >
      {children}
    </span>
  )
}
